module.exports = __webpack_public_path__ + "img/img_12.139f8fb9.png";